import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Subject, mergeMap, Subscription } from 'rxjs';
import { LoggerService } from '@lib.core/logger/logger.service';
import { AspectViewStore } from '@public/src/app/store/store-access/indicator-view.store';

@Injectable({
  providedIn: 'root'
})
export class AspectViewQParamInteractor {
  private readonly aspectViewParam = 'viewBlock';
  private readonly defaultAspectView = 'chart';
  private readonly subscriptions: Subscription[] = [];
  private logger: LoggerService;
  private readonly qParamReaderTrigger$$ = new Subject<void>();
  private readonly qParamReaderTrigger$ = this.qParamReaderTrigger$$.asObservable();

  constructor(
    private activatedRoute: ActivatedRoute,
    private aspectViewService: AspectViewStore
  ) {
    this.logger = LoggerService.getLoggerService();
    this.subscribeToQParamReader();
  }

  readAspectViewFromQParam() {
    this.qParamReaderTrigger$$.next();
  }

  destroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private subscribeToQParamReader() {
    this.subscriptions.push(
      this.qParamReaderTrigger$.pipe(
        mergeMap(() => this.activatedRoute.queryParams),
        map(qp => qp[this.aspectViewParam] ?? this.defaultAspectView)
      )
      .subscribe({
        next: (aspectViewNameId: string) => {
          this.aspectViewService.setAspectViewNameId(aspectViewNameId);
        },
        error: (error) => this.logger.error(error),
      })
    );
  }
}
